import React from 'react';
import Layout from '../components/layouts/Layout';

const NotFound: React.FC = () => {
  return (
    <Layout>
      <h1>404 - Page Not Found</h1>
      {/* Optional message or link to home page */}
    </Layout>
  );
}

export default NotFound;
